'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _stubbedChannel = require('../../threads/constants/stubbedChannel');

var _VisitorActionTypes = require('../../constants/VisitorActionTypes');

var ActionTypes = _interopRequireWildcard(_VisitorActionTypes);

var _markLastMessageReadByVisitor = require('../actions/markLastMessageReadByVisitor');

var _getIsOpen = require('../../selectors/getIsOpen');

var _clearUnseenCountForChannel = require('../../actions/ConversationsActions/clearUnseenCountForChannel');

var _isActiveOnChannel = require('../../selectors/clientSelectors/isActiveOnChannel');

var _sentByVisitorClient = require('../../pubnub-message/operators/sentByVisitorClient');

var _commonMessageFormatGetters = require('conversations-schema/common-message-format/operators/commonMessageFormatGetters');

var _messageTypeComparators = require('conversations-schema/pubnub-message/operators/messageTypeComparators');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var markLastMessageRead = function markLastMessageRead(_ref) {
  var store = _ref.store,
      conversation = _ref.conversation,
      messageTimestamp = _ref.messageTimestamp;

  store.dispatch((0, _markLastMessageReadByVisitor.markLastMessageReadByVisitor)({ conversation: conversation, messageTimestamp: messageTimestamp }));
};

var VisitorLastSeenMiddleware = function VisitorLastSeenMiddleware(store) {
  return function (next) {
    return function (action) {
      var state = store.getState();
      var currentChannel = state.currentChannel,
          conversations = state.conversations;

      var widgetIsOpen = (0, _getIsOpen.getIsOpen)(state);

      if (action.type === ActionTypes.SET_CURRENT_CHANNEL) {
        var channel = action.payload.channel;


        var _conversation = (0, _getIn2.default)(['conversations', 'conversationsMap', channel], state);

        if (!!channel && !!_conversation) {
          var prevChannel = state.currentChannel;

          if (prevChannel !== _stubbedChannel.STUBBED_CHANNEL && channel !== _stubbedChannel.STUBBED_CHANNEL && prevChannel !== channel && widgetIsOpen) {
            markLastMessageRead({ store: store, conversation: _conversation });
            store.dispatch((0, _clearUnseenCountForChannel.clearUnseenCountForChannel)({ channel: channel }));
          }
        }
      }

      if (action.type === ActionTypes.OUTGOING_MESSAGE_PUBLISHED) {
        if (currentChannel && action.payload && (0, _messageTypeComparators.isConversationalMessage)(action.payload.message)) {
          var _conversation2 = (0, _getIn2.default)(['conversations', 'conversationsMap', currentChannel], state);
          var messageTimestamp = (0, _commonMessageFormatGetters.getTimestamp)(action.payload.message);
          markLastMessageRead({
            store: store,
            conversation: _conversation2,
            messageTimestamp: messageTimestamp
          });
          store.dispatch((0, _clearUnseenCountForChannel.clearUnseenCountForChannel)({ channel: currentChannel }));
        }
      }

      if (action.type === ActionTypes.RECEIVED_INCOMING_MESSAGE) {
        var currentState = store.getState();
        var _action$payload = action.payload,
            _channel = _action$payload.channel,
            message = _action$payload.message;


        if (_channel && (0, _messageTypeComparators.isConversationalMessage)(message) && !(0, _sentByVisitorClient.sentByVisitorClient)(message) && (0, _isActiveOnChannel.isActiveOnChannel)(currentState, _channel)) {
          var _conversation3 = (0, _getIn2.default)(['conversations', 'conversationsMap', _channel], state);
          var _messageTimestamp = (0, _commonMessageFormatGetters.getTimestamp)(message);
          markLastMessageRead({ store: store, conversation: _conversation3, messageTimestamp: _messageTimestamp });
          store.dispatch((0, _clearUnseenCountForChannel.clearUnseenCountForChannel)({ channel: _channel }));
        }
      }

      var conversation = (0, _getIn2.default)(['conversationsMap', currentChannel], conversations);

      if (action.type === ActionTypes.APP_IN_FOREGROUND) {
        if (widgetIsOpen && currentChannel) {
          markLastMessageRead({ store: store, conversation: conversation });
          store.dispatch((0, _clearUnseenCountForChannel.clearUnseenCountForChannel)({ channel: currentChannel }));
        }
      }

      if (action.type === ActionTypes.TOGGLE_OPEN) {
        var _ref2 = action.payload || {},
            widgetWillOpen = _ref2.isOpened;

        if (widgetWillOpen && currentChannel) {
          markLastMessageRead({ store: store, conversation: conversation });
          store.dispatch((0, _clearUnseenCountForChannel.clearUnseenCountForChannel)({ channel: currentChannel }));
        }
      }

      return next(action);
    };
  };
};
exports.default = VisitorLastSeenMiddleware;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/last-seen/middleware/VisitorLastSeenMiddleware.js
// module id = 822
// module chunks = 2 3